import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceInfoService } from '../../../shared/services/device-info.service';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubContactorsService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
  ) {}

  async addContractor(requestData: any, params?: any) {
    return lastValueFrom(
      this.http
        .post('/api/sub-contractor/', requestData, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  async updateContractor(id: string, requestData: any, params?: any) {
    return lastValueFrom(
      this.http
        .put(`/api/sub-contractor/${id}/`, requestData, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  async getContactors(params?: any) {
    return lastValueFrom(
      this.http
        .get(`/api/sub-contractor/`, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  async getContactorDetailById(id: string, params?: any) {
    return lastValueFrom(
      this.http
        .get(`/api/sub-contractor/${id}/`, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
}
